<template>
  <thead>
  <tr>
    <th>ID</th>
    <th class="" @click="setOrder('last_name')"
        v-bind:class="[ this.order_by === 'last_name' ? 'fosorting_' + this.order_type : 'fosorting']">Name
    </th>
    <th class="" @click="setOrder('email')"
        v-bind:class="[ this.order_by === 'email' ? 'fosorting_' + this.order_type : 'fosorting']">Email
    </th>
    <th>Roles</th>
    <th class="text-center "></th>
  </tr>
  </thead>
</template>

<script>

export default {
  components: {},
  props: {},
  watch: {
    optionsData: {
      handler: function (val, oldVal) {
        this.initialize();
      },
      deep: true
    }
  },
  data() {
    return {
      opt: this.$store.getters['users/options']
    }
  },

  mounted() {
    this.initialize();
  },
  computed: {
    filters: function() {
      return this.$store.getters['users/filters'];
    },
    optionsData: function () {
      return this.$store.getters['users/options']
    },
    order_by: function () {
      return this.opt.order_by
    },
    order_type: function () {
      return this.opt.order_type
    },
  },
  methods: {
    initialize() {
      this.opt = {...this.optionsData};
    },
    setOrder: function (sortby) {
      if (this.opt.order_by === sortby) {
        this.opt.order_type = this.opt.order_type === 'asc' ? 'desc' : 'asc'
      } else {
        this.opt.order_by = sortby
        this.opt.order_type = 'asc'
      }
      this.$store.dispatch('users/setOptions', this.opt)
    }
  }
};
</script>
